"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePartneredHotspotRequestDto = exports.CreatePartneredHotspotRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class CreatePartneredHotspotRequestDto {}
exports.CreatePartneredHotspotRequestDto = CreatePartneredHotspotRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Public id of the partnered venue event.'
}), __metadata("design:type", String)], CreatePartneredHotspotRequestDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: "Start of the partnership window. Defaults to the event's start date."
}), __metadata("design:type", Object)], CreatePartneredHotspotRequestDto.prototype, "startsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: "End of the partnership window. Defaults to the event's end date."
}), __metadata("design:type", Object)], CreatePartneredHotspotRequestDto.prototype, "endsAt", void 0);
class UpdatePartneredHotspotRequestDto {}
exports.UpdatePartneredHotspotRequestDto = UpdatePartneredHotspotRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], UpdatePartneredHotspotRequestDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], UpdatePartneredHotspotRequestDto.prototype, "startsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], UpdatePartneredHotspotRequestDto.prototype, "endsAt", void 0);
//# sourceMappingURL=PartneredHotspotRequest.dto.js.map